import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import es from "./es.json";

const STORAGE_KEY = "prairie_lang";
const SUPPORTED = ["en", "es"];

const readStored = () => {
  if (typeof window === "undefined") return null;
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(v) ? v : null;
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[i18n] read stored lang failed:", e);
    return null;
  }
};

const initial =
  readStored() ||
  (typeof navigator !== "undefined" && navigator.language?.startsWith("es") ? "es" : "en");

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: initial,
  fallbackLng: "en",
  // Escape interpolated values by default. Static HTML tags inside translation
  // strings (like <b>, <u>) are still rendered via react-i18next's <Trans>
  // component, which maps them to safe JSX elements. Interpolated {{values}}
  // are always escaped, preventing stored-XSS via user/AI-generated plant names.
  interpolation: { escapeValue: true },
  returnObjects: true,
});

export const setLanguage = (lng) => {
  if (!SUPPORTED.includes(lng)) return;
  i18n.changeLanguage(lng);
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[i18n] persist lang failed:", e);
  }
  if (typeof document !== "undefined") document.documentElement.lang = lng;
};

// Apply initial lang attribute
if (typeof document !== "undefined") document.documentElement.lang = initial;

export default i18n;
